import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDiamond = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.672 4.515h.697l2.537 4.177h-5.78zM7.368 8.692l2.547-4.177h-3.08a.7.7 0 0 0-.322.094.8.8 0 0 0-.272.26l-.008.011-2.587 3.792-.013.02zm-3.29 1.5h3.2l2.917 7.462zm4.81 0h6.25l-3.136 7.965zm7.862 0-2.93 7.444 6.103-7.444zm3.617-1.5-.013-.02-2.587-3.792-.008-.011a.8.8 0 0 0-.271-.26.7.7 0 0 0-.323-.094h-3.04l2.536 4.177zm-3.19-5.677h-4.246a.8.8 0 0 0-.298 0H11.41a.8.8 0 0 0-.299 0h-4.31c-.364.01-.719.112-1.034.293-.313.18-.578.431-.777.732L2.405 7.83l-.004.006c-.283.423-.421.928-.399 1.436.023.509.205 1 .525 1.395l.003.004 7.755 9.458c.197.264.45.481.744.633a2.11 2.11 0 0 0 1.942 0c.293-.152.547-.37.744-.633l7.755-9.458.003-.004a2.399 2.399 0 0 0 .126-2.831l-.004-.006-2.585-3.79a2.3 2.3 0 0 0-.777-.732 2.2 2.2 0 0 0-1.055-.293"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDiamond;
